export default "__VITE_ASSET__DRPDmtjZ__"